import { isObject } from '@iconik-io/core/src/is_object';

import type {
  FilterValue,
  FilterValueMultiDropdown,
} from '../../redux/common_filters/types';

function isStringArray(values: unknown[]): values is string[] {
  return values.every((value) => typeof value === 'string');
}

function isMultiDropdownArray(
  values: unknown[],
): values is FilterValueMultiDropdown[] {
  return values.every(
    (value) => isObject(value) && 'label' in value && 'value' in value,
  );
}

export function guardFilterGeneric(
  filterValue: FilterValue,
): string[] | undefined {
  if (!Array.isArray(filterValue) || filterValue.length === 0) {
    return undefined;
  }
  if (isStringArray(filterValue)) {
    return filterValue;
  }
  if (isMultiDropdownArray(filterValue)) {
    return filterValue.map((item) => item.value);
  }
  return undefined;
}
